import {DialogManagerActions, IDialogManagerState} from "./types";
import {Reducer} from "redux";
import {getType} from "typesafe-actions";
import * as actions from "./actions";

const initialState: IDialogManagerState = {

};

export const dialogManagerReducer: Reducer<IDialogManagerState, DialogManagerActions> = (state = initialState, action) => {
    switch (action.type) {
        case getType(actions.actuallyShowDialog):
            return {
                ...state,
                currentDialog: action.payload
            };

        case getType(actions.closeDialog):
            return {
                ...state,
                currentDialog: undefined
            };

        default:
            return state;
    }
};
